export default __webpack_public_path__ + "static/media/pop-up.778a5be5.png";